(() => {
  const SELECTOR = '[data-contact-root]';

  const reduceMotion = () =>
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;

  const cleanContactParameter = () => {
    if (!window.history?.replaceState) return;

    const url = new URL(window.location.href);
    if (!url.searchParams.has('contact_posted')) return;

    url.searchParams.delete('contact_posted');
    window.history.replaceState({}, document.title, url.toString());
  };

  const focusMessage = (element, shouldScroll = false) => {
    if (!element) return;

    window.setTimeout(() => {
      element.focus({ preventScroll: true });

      if (shouldScroll) {
        element.scrollIntoView({
          behavior: reduceMotion() ? 'auto' : 'smooth',
          block: 'center',
        });
      }
    }, 100);
  };

  const updateCounter = (textarea, counter) => {
    if (!textarea || !counter) return;

    const max = Number.parseInt(textarea.getAttribute('maxlength') || '2000', 10);
    counter.textContent = `${textarea.value.length} / ${max}`;
  };

  const keepDigitsOnly = (input) => {
    if (!input) return;

    const digits = input.value.replace(/\D/g, '');
    if (input.value !== digits) input.value = digits;
  };

  const formatOrderNumber = (input) => {
    if (!input) return;

    const digits = input.value.replace(/\D/g, '');
    const formatted = digits ? `#${digits}` : '';
    if (input.value !== formatted) input.value = formatted;
  };

  const init = (root) => {
    if (!root || root.dataset.contactInitialized === 'true') return;

    root.dataset.contactInitialized = 'true';

    const form = root.querySelector('form');
    const error = root.querySelector('[data-contact-error]');
    const success = root.querySelector('[data-contact-success]');
    const honeypot = root.querySelector('[data-contact-honeypot]');
    const textarea = root.querySelector('[data-contact-message]');
    const counter = root.querySelector('[data-contact-counter]');
    const phone = root.querySelector('[data-contact-phone]');
    const order = root.querySelector('[data-contact-order]');

    keepDigitsOnly(phone);
    formatOrderNumber(order);

    phone?.addEventListener('input', () => keepDigitsOnly(phone));
    order?.addEventListener('input', () => formatOrderNumber(order));

    updateCounter(textarea, counter);
    textarea?.addEventListener('input', () => updateCounter(textarea, counter));

    if (error) focusMessage(error);

    if (success) {
      focusMessage(success, true);
      cleanContactParameter();
    }

    if (form && honeypot) {
      form.addEventListener('submit', (event) => {
        if (honeypot.value.trim() !== '') {
          event.preventDefault();
          return;
        }

        form.dataset.submitting = 'true';
      });
    }
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
